export default {
  'component.globalHeader.search': 'Pencarian',
  'component.globalHeader.search.example1': 'Contoh 1 Pencarian',
  'component.globalHeader.search.example2': 'Contoh 2 Pencarian',
  'component.globalHeader.search.example3': 'Contoh 3 Pencarian',
  'component.globalHeader.help': 'Bantuan',
  'component.globalHeader.notification': 'Notifikasi',
  'component.globalHeader.notification.empty':
    'Anda telah membaca semua notifikasi',
  'component.globalHeader.message': 'Pesan',
  'component.globalHeader.message.empty': 'Anda telah membaca semua pesan.',
  'component.globalHeader.event': 'Acara',
  'component.globalHeader.event.empty': 'Anda telah melihat semua acara.',
  'component.noticeIcon.clear': 'Kosongkan',
  'component.noticeIcon.cleared': 'Berhasil dikosongkan',
  'component.noticeIcon.empty': 'Tidak ada pemberitahuan',
  'component.noticeIcon.view-more': 'Melihat lebih',
};
